import { jsx as _jsx } from "react/jsx-runtime";
import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
export const ReduxContextWrapper = (InnerComponent, store) => (props) => (_jsx(Provider, { store: store, children: _jsx(InnerComponent, { ...props }) }));
export const ApolloContextWrapper = (InnerComponent, apolloClient) => (props) => (_jsx(ApolloProvider, { client: apolloClient, children: _jsx(InnerComponent, { ...props }) }));
